export default {
  data() {
    return {
      useNullableCleanersOk: true,
    };
  },
  computed: {
    cleanersOkItems() {
      const items = [];
      if (this.useNullableCleanersOk) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      items.push({
        text: this.lang(this.$store, 'sap/listings.global.filter.statuses.yes'),
        value: 1,
      });
      items.push({
        text: this.lang(this.$store, 'sap/listings.global.filter.statuses.no'),
        value: 0,
      });
      return items;
    },
  },
};
